export default __webpack_public_path__ + "static/media/logo-dior-300x300.e4407354.jpg";